import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { Icon } from '@/shared/ui/icon'

type KeysBalanceProps = {
  balance: number
}

export const KeysBalance = (props: KeysBalanceProps) => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.main.dailyCaseBanner.yourKeys
  const { balance } = props
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <span className={classes.yourKeysText}>{text}</span>
        <Icon
          view="gamedKey"
          width={32}
          style={{ marginLeft: '4px' }}
        />
        <span className={classes.keysAmount}>{balance}</span>
      </div>
    </div>
  )
}
